<template>
  <div class="container" v-if="!isLoading">
    <div class="row">
      <div class="col-12">
        <TopNav class="mt-4" />
        <img class="mt-3" :srcset="`${logo} 3x`" />
        <div class="mt-4">
          {{ $t('SETTINGS.TEXT.REWARDFUL_DESCRIPTION') }}
        </div>
        <div class="mt-2 mb-4">
          <a href="https://www.rewardful.com/?via=marvelous" target="_blank">{{
            $t('SETTINGS.TEXT.REWARDFUL_SIGNUP')
          }}</a>
        </div>
      </div>
      <div class="col-12">
        <HMTextInput
          :label="$t('SETTINGS.LABEL.REWARDFUL_API_KEY')"
          v-model="rewardfulKey"
        ></HMTextInput>
      </div>
      <hr class="mx-3 w-100" />
      <div class="col-12 form-group">
        <HMButton color="primary" @click="update" :loading="inProgress">
          {{ $t('SETTINGS.BUTTON.UPDATE') }}
        </HMButton>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import TopNav from '@/web/components/navigation/TopNav.vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'RewardfulIntegration',
  components: {
    TopNav,
  },
  data() {
    return {
      logo: '/assets/images/integrations/rewardful-logo.svg',
      isLoading: true,
      inProgress: false,
      rewardfulKey: null,
    };
  },
  methods: {
    async update() {
      this.inProgress = true;

      try {
        await this.$store.dispatch(
          'setting/updateRewardfulKey',
          this.rewardfulKey
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'SETTINGS.NOTIFICATIONS.REWARDFUL_KEY_SUCCESSFULLY_UPDATED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
      this.inProgress = false;
    },
    remove() {
      this.rewardfulKey = null;
      this.update();
    },
  },
  async mounted() {
    this.rewardfulKey = await this.$store.dispatch('setting/getRewardfulKey');
    this.isLoading = false;
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
